export default "__VITE_ASSET__TrXHk6ZO__"